import { message, notification } from "antd";
import { useState } from "react";
import { authApis } from "../../../services/authApi";
import AuthLayout from "./../../../components/auth/authLayout";
import { setAccessToken } from "./../../../helper/localStorage";
import "./index.scss";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Register = () => {
    const history = useNavigate();
    const [valueForm, setValueForm] = useState({
        name: "",
        email: "",
        password: "",
        password_confirmed: "",
    });

    const onChangeValue = (values) => {
        setValueForm({
            ...valueForm,
            [values.target.name]: values.target.value,
        });
    };
    const openNotificationWithIcon = (type) => {
        notification[type]({
            message: 'Thành công',
            description:
                'Đăng ký thành công !',
        });
    };
    const onSubmit = async (event) => {
        event.preventDefault();
        if (!valueForm.name) {
            message.error("Xin vui lòng nhập tên");
            return;
        }
        if (!valueForm.email) {
            message.error("Xin vui lòng nhập email");
            return;
        }
        if (!valueForm.password) {
            message.error("Xin vui lòng nhập mật khẩu");
            return;
        }

        if (valueForm.password !== valueForm.password_confirmed) {
            message.error("Mật khẩu không khớp với nhau vui lòng nhập lại");
            return;
        }
        const res = await authApis
            .register(valueForm)
            .then((data) => {
                if (data.status_code === 200) {
                    openNotificationWithIcon('success');
                    setAccessToken(data.token);
                    history.push("/login");
                } else if (data.status_code == 500) {
                    message.error(data.message);
                } else if (data.status_code == 422) {
                    message.error(data.message);
                }
            })
            .catch((errors) => {
                console.log(errors);
            });
        return res;
    };

    return (
        <AuthLayout>
            <div className="col-lg-12">
                <div className="p-4">
                    <div className="text-center">
                        <h3 className="h5 text-gray-900 mb-4">
                            Create an Account!
                        </h3>
                    </div>
                    <form className="user" onSubmit={onSubmit}>
                        <div className="form-group">
                            <input
                                type="text"
                                className="form-control"
                                id="exampleFirstName"
                                name="name"
                                placeholder="Name"
                                onChange={onChangeValue}
                            />
                        </div>
                        <div className="form-group">
                            <input
                                type="email"
                                className="form-control"
                                id="exampleInputEmail"
                                name="email"
                                placeholder="Email Address"
                                onChange={onChangeValue}
                            />
                        </div>
                        <div className="form-group">
                            <input
                                type="password"
                                className="form-control"
                                id="exampleInputPassword"
                                name="password"
                                placeholder="Password"
                                onChange={onChangeValue}
                            />
                        </div>
                        <div className="form-group">
                            <input
                                type="password"
                                className="form-control"
                                id="exampleRepeatPassword"
                                name="password_confirmed"
                                placeholder="Repeat Password"
                                onChange={onChangeValue}
                            />
                        </div>
                        <div className="form-group">
                            <div className="d-flex justify-content-end align-items-center">
                                <button
                                    className="btn"
                                    style={{
                                        color: "white",
                                        background: "black",
                                        padding: "5px 20px",
                                    }}
                                >
                                    Register Account
                                </button>
                            </div>
                        </div>
                    </form>
                    <div className="text-left">
                        <Link
                            className="small"
                            to="/forgot-password"
                            style={{ color: "red" }}
                        >
                            I forgot my password?
                        </Link>
                    </div>
                    <div className="text-left">
                        <Link
                            className="small"
                            to="/login"
                            style={{ color: "black" }}
                        >
                            Already have an account? Login!
                        </Link>
                    </div>
                </div>
            </div>
        </AuthLayout>
    );
};

export default Register;
